var map = {
	"./2015_spring_CJ_Entus.png": 8845,
	"./2015_spring_Incredible_Miracle.png": 1741,
	"./2015_spring_Jin_Air_Greenwings.png": 374,
	"./2015_spring_KOO_Tigers.png": 4696,
	"./2015_spring_KT_Rolster.png": 9131,
	"./2015_spring_Najin_e_Emfire.png": 8299,
	"./2015_spring_SKTelecom_T1.png": 5633,
	"./2015_spring_Samsung_Galaxy.png": 3827,
	"./2015_summer_Anarchy.png": 9324,
	"./2015_summer_CJ_Entus.png": 2997,
	"./2015_summer_Incredible_Miracle.png": 9285,
	"./2015_summer_Jin_Air_Greenwings.png": 5870,
	"./2015_summer_KOO_Tigers.png": 1312,
	"./2015_summer_KT_Rolster.png": 5571,
	"./2015_summer_Najin_e_Emfire.png": 3427,
	"./2015_summer_SBENU.png": 7797,
	"./2015_summer_SKTelecom_T1.png": 2569,
	"./2015_summer_Samsung_Galaxy.png": 7003,
	"./2016_spring_Afreeca_Freecs.png": 1073,
	"./2016_spring_CJ_Entus.png": 1122,
	"./2016_spring_Jin_Air_Green_Wings.png": 8036,
	"./2016_spring_KT_Rolster.png": 1736,
	"./2016_spring_Kongdoo_Monster.png": 9279,
	"./2016_spring_Longzhu_Gaming.png": 3444,
	"./2016_spring_ROX_Tigers.png": 8289,
	"./2016_spring_SBENU_Sonicboom.png": 7972,
	"./2016_spring_SK_Telecom_T1.png": 2933,
	"./2016_spring_Samsung_Galaxy.png": 7180,
	"./2016_summer_Afreeca_Freecs.png": 249,
	"./2016_summer_CJ_Entus.png": 698,
	"./2016_summer_ESC_Ever.png": 1485,
	"./2016_summer_Jin_Air_Green_Wings.png": 2268,
	"./2016_summer_KT_Rolster.png": 8192,
	"./2016_summer_Longzhu_Gaming.png": 3804,
	"./2016_summer_MVP.png": 4708,
	"./2016_summer_ROX_Tigers.png": 8697,
	"./2016_summer_SK_Telecom_T1.png": 9789,
	"./2016_summer_Samsung_Galaxy.png": 2660,
	"./2017_spring_Afreeca_Freecs.png": 6716,
	"./2017_spring_Ever8_Winners.png": 4265,
	"./2017_spring_Jin_Air_Green_Wings.png": 9919,
	"./2017_spring_KT_Rolster.png": 2721,
	"./2017_spring_Kongdoo_Monster.png": 7232,
	"./2017_spring_Longzhu_Gaming.png": 717,
	"./2017_spring_MVP.png": 7871,
	"./2017_spring_ROX_Tigers.png": 4564,
	"./2017_spring_SK_Telecom_T1.png": 7274,
	"./2017_spring_Samsung_Galaxy.png": 5102,
	"./2017_spring_bbq_Olivers.png": 6500,
	"./2017_summer_Afreeca_Freecs.png": 8396,
	"./2017_summer_Ever8_Winners.png": 4937,
	"./2017_summer_Jin_Air_Green_Wings.png": 5919,
	"./2017_summer_KT_Rolster.png": 97,
	"./2017_summer_Longzhu_Gaming.png": 5597,
	"./2017_summer_MVP.png": 7855,
	"./2017_summer_ROX_Tigers.png": 9268,
	"./2017_summer_SK_Telecom_T1.png": 1034,
	"./2017_summer_Samsung_Galaxy.png": 6433,
	"./2017_summer_bbq_Olivers.png": 8724,
	"./2018_spring_Afreeca_Freecs.png": 5439,
	"./2018_spring_Gen_G_eSports.png": 7500,
	"./2018_spring_Jin_Air_Green_Wings.png": 6738,
	"./2018_spring_KT_Rolster.png": 1214,
	"./2018_spring_Kingzone_DragonX.png": 3288,
	"./2018_spring_Kongdoo_Monster.png": 8653,
	"./2018_spring_MVP.png": 6626,
	"./2018_spring_ROX_Tigers.png": 6431,
	"./2018_spring_SK_Telecom_T1.png": 9799,
	"./2018_spring_bbq_Olivers.png": 3609,
	"./2018_summer_Afreeca_Freecs.png": 3607,
	"./2018_summer_Gen_G_eSports.png": 5572,
	"./2018_summer_Griffin.png": 3080,
	"./2018_summer_Hanwha_Life_eSports.png": 7622,
	"./2018_summer_Jin_Air_Green_Wings.png": 6122,
	"./2018_summer_KT_Rolster.png": 3302,
	"./2018_summer_Kingzone_DragonX.png": 1696,
	"./2018_summer_MVP.png": 6570,
	"./2018_summer_SK_Telecom_T1.png": 8815,
	"./2018_summer_bbq_Olivers.png": 6385,
	"./2019_spring_Afreeca_Freecs.png": 1690,
	"./2019_spring_DAMWON_Gaming.png": 4052,
	"./2019_spring_Gen_G_eSports.png": 4663,
	"./2019_spring_Griffin.png": 9043,
	"./2019_spring_Hanwha_Life_eSports.png": 7849,
	"./2019_spring_Jin_Air_Green_Wings.png": 4861,
	"./2019_spring_KT_Rolster.png": 7823,
	"./2019_spring_Kingzone_DragonX.png": 2081,
	"./2019_spring_SK_Telecom_T1.png": 5364,
	"./2019_spring_Sandbox_Gaming.png": 9379,
	"./2019_summer_Afreeca_Freecs.png": 1090,
	"./2019_summer_DAMWON_Gaming.png": 7356,
	"./2019_summer_Gen_G_eSports.png": 95,
	"./2019_summer_Griffin.png": 8363,
	"./2019_summer_Hanwha_Life_eSports.png": 9265,
	"./2019_summer_Jin_Air_Green_Wings.png": 1861,
	"./2019_summer_KT_Rolster.png": 1623,
	"./2019_summer_Kingzone_DragonX.png": 2713,
	"./2019_summer_SK_Telecom_T1.png": 8380,
	"./2019_summer_Sandbox_Gaming.png": 2827,
	"./2020_spring_Afreeca_Freecs.png": 8586,
	"./2020_spring_DAMWON_Gaming.png": 4119,
	"./2020_spring_DragonX.png": 1809,
	"./2020_spring_Gen_G_eSports.png": 9639,
	"./2020_spring_Griffin.png": 1331,
	"./2020_spring_Hanwha_Life_eSports.png": 9705,
	"./2020_spring_KT_Rolster.png": 3695,
	"./2020_spring_Sandbox_Gaming.png": 1795,
	"./2020_spring_SeolHaeOne_Prince.png": 7095,
	"./2020_spring_T1.png": 7733,
	"./2020_summer_Afreeca_Freecs.png": 4178,
	"./2020_summer_DAMWON_Gaming.png": 8972,
	"./2020_summer_DragonX.png": 4745,
	"./2020_summer_Gen_G_eSports.png": 9071,
	"./2020_summer_Hanwha_Life_eSports.png": 8769,
	"./2020_summer_KT_Rolster.png": 2023,
	"./2020_summer_Sandbox_Gaming.png": 3963,
	"./2020_summer_SeolHaeOne_Prince.png": 6879,
	"./2020_summer_T1.png": 3005,
	"./2020_summer_Team_Dynamics.png": 5398,
	"./2021_spring_Afreeca_Freecs.png": 8495,
	"./2021_spring_DRX.png": 2955,
	"./2021_spring_DWG_KIA.png": 6627,
	"./2021_spring_Fredit_BRION.png": 5758,
	"./2021_spring_Gen_G_eSports.png": 8124,
	"./2021_spring_Hanwha_Life_eSports.png": 7838,
	"./2021_spring_KT_Rolster.png": 8926,
	"./2021_spring_Liiv_SANDBOX.png": 7349,
	"./2021_spring_Nongshim_RedForce.png": 6025,
	"./2021_spring_T1.png": 4320,
	"./2021_summer_Afreeca_Freecs.png": 5031,
	"./2021_summer_DRX.png": 8355,
	"./2021_summer_DWG_KIA.png": 9291,
	"./2021_summer_Fredit_BRION.png": 1942,
	"./2021_summer_Gen_G_eSports.png": 6452,
	"./2021_summer_Hanwha_Life_eSports.png": 1222,
	"./2021_summer_KT_Rolster.png": 3606,
	"./2021_summer_Liiv_SANDBOX.png": 4733,
	"./2021_summer_Nongshim_RedForce.png": 5937,
	"./2021_summer_T1.png": 4168,
	"./2022_spring_DRX.png": 9962,
	"./2022_spring_DWG_KIA.png": 4778,
	"./2022_spring_Fredit_BRION.png": 6581,
	"./2022_spring_Gen_G_eSports.png": 333,
	"./2022_spring_Hanwha_Life_eSports.png": 6663,
	"./2022_spring_KT_Rolster.png": 2245,
	"./2022_spring_Kwangdong_Freecs.png": 9001,
	"./2022_spring_Liiv_SANDBOX.png": 7742,
	"./2022_spring_Nongshim_RedForce.png": 532,
	"./2022_spring_T1.png": 2587,
	"./2022_summer_DRX.png": 8522,
	"./2022_summer_DWG_KIA.png": 4282,
	"./2022_summer_Fredit_BRION.png": 5221,
	"./2022_summer_Gen_G_eSports.png": 1501,
	"./2022_summer_Hanwha_Life_eSports.png": 5383,
	"./2022_summer_KT_Rolster.png": 693,
	"./2022_summer_Kwangdong_Freecs.png": 7641,
	"./2022_summer_Liiv_SANDBOX.png": 1278,
	"./2022_summer_Nongshim_RedForce.png": 3620,
	"./2022_summer_T1.png": 9227,
	"./2023_spring_BRION.png": 7973,
	"./2023_spring_DRX.png": 5129,
	"./2023_spring_Dplus_KIA.png": 6343,
	"./2023_spring_Gen_G_eSports.png": 7082,
	"./2023_spring_Hanwha_Life_eSports.png": 6700,
	"./2023_spring_KT_Rolster.png": 6076,
	"./2023_spring_Kwangdong_Freecs.png": 9280,
	"./2023_spring_Liiv_SANDBOX.png": 7867,
	"./2023_spring_Nongshim_RedForce.png": 807,
	"./2023_spring_T1.png": 3710,
	"./2023_summer_BRION.png": 237,
	"./2023_summer_DRX.png": 6369,
	"./2023_summer_Dplus_KIA.png": 2815,
	"./2023_summer_Gen_G_eSports.png": 6594,
	"./2023_summer_Hanwha_Life_eSports.png": 5764,
	"./2023_summer_KT_Rolster.png": 8884,
	"./2023_summer_Kwangdong_Freecs.png": 8968,
	"./2023_summer_Liiv_SANDBOX.png": 9683,
	"./2023_summer_Nongshim_RedForce.png": 6703,
	"./2024_spring_DRX.png": 8120,
	"./2024_spring_Dplus_KIA.png": 2250,
	"./2024_spring_FearX.png": 9036,
	"./2024_spring_Gen_G_eSports.png": 3819,
	"./2024_spring_Hanwha_Life_eSports.png": 7701,
	"./2024_spring_KT_Rolster.png": 5827,
	"./2024_spring_Kwangdong_Freecs.png": 3583,
	"./2024_spring_Nongshim_RedForce.png": 9930,
	"./2024_spring_OK_BRION.png": 5261,
	"./2024_spring_T1.png": 6817,
	"./2024_summer_DRX.png": 4656,
	"./2024_summer_Dplus_KIA.png": 6178,
	"./2024_summer_FearX.png": 1332,
	"./2024_summer_Gen_G_eSports.png": 2467,
	"./2024_summer_Hanwha_Life_eSports.png": 1133,
	"./2024_summer_KT_Rolster.png": 4091,
	"./2024_summer_Kwangdong_Freecs.png": 6311,
	"./2024_summer_Nongshim_RedForce.png": 562,
	"./2024_summer_OK_BRION.png": 8517,
	"./2024_summer_T1.png": 4361,
	"./2025_spring_BNK_FearX.png": 4689,
	"./2025_spring_DN_Freecs.png": 3592,
	"./2025_spring_DRX.png": 9087,
	"./2025_spring_Dplus_KIA.png": 9725,
	"./2025_spring_Gen_G_eSports.png": 8944,
	"./2025_spring_Hanwha_Life_eSports.png": 10,
	"./2025_spring_KT_Rolster.png": 146,
	"./2025_spring_Nongshim_RedForce.png": 5709,
	"./2025_spring_OK_BRION.png": 7812,
	"./2025_spring_T1.png": 9436,
	"assets/logos/2015_spring_CJ_Entus.png": 8845,
	"assets/logos/2015_spring_Incredible_Miracle.png": 1741,
	"assets/logos/2015_spring_Jin_Air_Greenwings.png": 374,
	"assets/logos/2015_spring_KOO_Tigers.png": 4696,
	"assets/logos/2015_spring_KT_Rolster.png": 9131,
	"assets/logos/2015_spring_Najin_e_Emfire.png": 8299,
	"assets/logos/2015_spring_SKTelecom_T1.png": 5633,
	"assets/logos/2015_spring_Samsung_Galaxy.png": 3827,
	"assets/logos/2015_summer_Anarchy.png": 9324,
	"assets/logos/2015_summer_CJ_Entus.png": 2997,
	"assets/logos/2015_summer_Incredible_Miracle.png": 9285,
	"assets/logos/2015_summer_Jin_Air_Greenwings.png": 5870,
	"assets/logos/2015_summer_KOO_Tigers.png": 1312,
	"assets/logos/2015_summer_KT_Rolster.png": 5571,
	"assets/logos/2015_summer_Najin_e_Emfire.png": 3427,
	"assets/logos/2015_summer_SBENU.png": 7797,
	"assets/logos/2015_summer_SKTelecom_T1.png": 2569,
	"assets/logos/2015_summer_Samsung_Galaxy.png": 7003,
	"assets/logos/2016_spring_Afreeca_Freecs.png": 1073,
	"assets/logos/2016_spring_CJ_Entus.png": 1122,
	"assets/logos/2016_spring_Jin_Air_Green_Wings.png": 8036,
	"assets/logos/2016_spring_KT_Rolster.png": 1736,
	"assets/logos/2016_spring_Kongdoo_Monster.png": 9279,
	"assets/logos/2016_spring_Longzhu_Gaming.png": 3444,
	"assets/logos/2016_spring_ROX_Tigers.png": 8289,
	"assets/logos/2016_spring_SBENU_Sonicboom.png": 7972,
	"assets/logos/2016_spring_SK_Telecom_T1.png": 2933,
	"assets/logos/2016_spring_Samsung_Galaxy.png": 7180,
	"assets/logos/2016_summer_Afreeca_Freecs.png": 249,
	"assets/logos/2016_summer_CJ_Entus.png": 698,
	"assets/logos/2016_summer_ESC_Ever.png": 1485,
	"assets/logos/2016_summer_Jin_Air_Green_Wings.png": 2268,
	"assets/logos/2016_summer_KT_Rolster.png": 8192,
	"assets/logos/2016_summer_Longzhu_Gaming.png": 3804,
	"assets/logos/2016_summer_MVP.png": 4708,
	"assets/logos/2016_summer_ROX_Tigers.png": 8697,
	"assets/logos/2016_summer_SK_Telecom_T1.png": 9789,
	"assets/logos/2016_summer_Samsung_Galaxy.png": 2660,
	"assets/logos/2017_spring_Afreeca_Freecs.png": 6716,
	"assets/logos/2017_spring_Ever8_Winners.png": 4265,
	"assets/logos/2017_spring_Jin_Air_Green_Wings.png": 9919,
	"assets/logos/2017_spring_KT_Rolster.png": 2721,
	"assets/logos/2017_spring_Kongdoo_Monster.png": 7232,
	"assets/logos/2017_spring_Longzhu_Gaming.png": 717,
	"assets/logos/2017_spring_MVP.png": 7871,
	"assets/logos/2017_spring_ROX_Tigers.png": 4564,
	"assets/logos/2017_spring_SK_Telecom_T1.png": 7274,
	"assets/logos/2017_spring_Samsung_Galaxy.png": 5102,
	"assets/logos/2017_spring_bbq_Olivers.png": 6500,
	"assets/logos/2017_summer_Afreeca_Freecs.png": 8396,
	"assets/logos/2017_summer_Ever8_Winners.png": 4937,
	"assets/logos/2017_summer_Jin_Air_Green_Wings.png": 5919,
	"assets/logos/2017_summer_KT_Rolster.png": 97,
	"assets/logos/2017_summer_Longzhu_Gaming.png": 5597,
	"assets/logos/2017_summer_MVP.png": 7855,
	"assets/logos/2017_summer_ROX_Tigers.png": 9268,
	"assets/logos/2017_summer_SK_Telecom_T1.png": 1034,
	"assets/logos/2017_summer_Samsung_Galaxy.png": 6433,
	"assets/logos/2017_summer_bbq_Olivers.png": 8724,
	"assets/logos/2018_spring_Afreeca_Freecs.png": 5439,
	"assets/logos/2018_spring_Gen_G_eSports.png": 7500,
	"assets/logos/2018_spring_Jin_Air_Green_Wings.png": 6738,
	"assets/logos/2018_spring_KT_Rolster.png": 1214,
	"assets/logos/2018_spring_Kingzone_DragonX.png": 3288,
	"assets/logos/2018_spring_Kongdoo_Monster.png": 8653,
	"assets/logos/2018_spring_MVP.png": 6626,
	"assets/logos/2018_spring_ROX_Tigers.png": 6431,
	"assets/logos/2018_spring_SK_Telecom_T1.png": 9799,
	"assets/logos/2018_spring_bbq_Olivers.png": 3609,
	"assets/logos/2018_summer_Afreeca_Freecs.png": 3607,
	"assets/logos/2018_summer_Gen_G_eSports.png": 5572,
	"assets/logos/2018_summer_Griffin.png": 3080,
	"assets/logos/2018_summer_Hanwha_Life_eSports.png": 7622,
	"assets/logos/2018_summer_Jin_Air_Green_Wings.png": 6122,
	"assets/logos/2018_summer_KT_Rolster.png": 3302,
	"assets/logos/2018_summer_Kingzone_DragonX.png": 1696,
	"assets/logos/2018_summer_MVP.png": 6570,
	"assets/logos/2018_summer_SK_Telecom_T1.png": 8815,
	"assets/logos/2018_summer_bbq_Olivers.png": 6385,
	"assets/logos/2019_spring_Afreeca_Freecs.png": 1690,
	"assets/logos/2019_spring_DAMWON_Gaming.png": 4052,
	"assets/logos/2019_spring_Gen_G_eSports.png": 4663,
	"assets/logos/2019_spring_Griffin.png": 9043,
	"assets/logos/2019_spring_Hanwha_Life_eSports.png": 7849,
	"assets/logos/2019_spring_Jin_Air_Green_Wings.png": 4861,
	"assets/logos/2019_spring_KT_Rolster.png": 7823,
	"assets/logos/2019_spring_Kingzone_DragonX.png": 2081,
	"assets/logos/2019_spring_SK_Telecom_T1.png": 5364,
	"assets/logos/2019_spring_Sandbox_Gaming.png": 9379,
	"assets/logos/2019_summer_Afreeca_Freecs.png": 1090,
	"assets/logos/2019_summer_DAMWON_Gaming.png": 7356,
	"assets/logos/2019_summer_Gen_G_eSports.png": 95,
	"assets/logos/2019_summer_Griffin.png": 8363,
	"assets/logos/2019_summer_Hanwha_Life_eSports.png": 9265,
	"assets/logos/2019_summer_Jin_Air_Green_Wings.png": 1861,
	"assets/logos/2019_summer_KT_Rolster.png": 1623,
	"assets/logos/2019_summer_Kingzone_DragonX.png": 2713,
	"assets/logos/2019_summer_SK_Telecom_T1.png": 8380,
	"assets/logos/2019_summer_Sandbox_Gaming.png": 2827,
	"assets/logos/2020_spring_Afreeca_Freecs.png": 8586,
	"assets/logos/2020_spring_DAMWON_Gaming.png": 4119,
	"assets/logos/2020_spring_DragonX.png": 1809,
	"assets/logos/2020_spring_Gen_G_eSports.png": 9639,
	"assets/logos/2020_spring_Griffin.png": 1331,
	"assets/logos/2020_spring_Hanwha_Life_eSports.png": 9705,
	"assets/logos/2020_spring_KT_Rolster.png": 3695,
	"assets/logos/2020_spring_Sandbox_Gaming.png": 1795,
	"assets/logos/2020_spring_SeolHaeOne_Prince.png": 7095,
	"assets/logos/2020_spring_T1.png": 7733,
	"assets/logos/2020_summer_Afreeca_Freecs.png": 4178,
	"assets/logos/2020_summer_DAMWON_Gaming.png": 8972,
	"assets/logos/2020_summer_DragonX.png": 4745,
	"assets/logos/2020_summer_Gen_G_eSports.png": 9071,
	"assets/logos/2020_summer_Hanwha_Life_eSports.png": 8769,
	"assets/logos/2020_summer_KT_Rolster.png": 2023,
	"assets/logos/2020_summer_Sandbox_Gaming.png": 3963,
	"assets/logos/2020_summer_SeolHaeOne_Prince.png": 6879,
	"assets/logos/2020_summer_T1.png": 3005,
	"assets/logos/2020_summer_Team_Dynamics.png": 5398,
	"assets/logos/2021_spring_Afreeca_Freecs.png": 8495,
	"assets/logos/2021_spring_DRX.png": 2955,
	"assets/logos/2021_spring_DWG_KIA.png": 6627,
	"assets/logos/2021_spring_Fredit_BRION.png": 5758,
	"assets/logos/2021_spring_Gen_G_eSports.png": 8124,
	"assets/logos/2021_spring_Hanwha_Life_eSports.png": 7838,
	"assets/logos/2021_spring_KT_Rolster.png": 8926,
	"assets/logos/2021_spring_Liiv_SANDBOX.png": 7349,
	"assets/logos/2021_spring_Nongshim_RedForce.png": 6025,
	"assets/logos/2021_spring_T1.png": 4320,
	"assets/logos/2021_summer_Afreeca_Freecs.png": 5031,
	"assets/logos/2021_summer_DRX.png": 8355,
	"assets/logos/2021_summer_DWG_KIA.png": 9291,
	"assets/logos/2021_summer_Fredit_BRION.png": 1942,
	"assets/logos/2021_summer_Gen_G_eSports.png": 6452,
	"assets/logos/2021_summer_Hanwha_Life_eSports.png": 1222,
	"assets/logos/2021_summer_KT_Rolster.png": 3606,
	"assets/logos/2021_summer_Liiv_SANDBOX.png": 4733,
	"assets/logos/2021_summer_Nongshim_RedForce.png": 5937,
	"assets/logos/2021_summer_T1.png": 4168,
	"assets/logos/2022_spring_DRX.png": 9962,
	"assets/logos/2022_spring_DWG_KIA.png": 4778,
	"assets/logos/2022_spring_Fredit_BRION.png": 6581,
	"assets/logos/2022_spring_Gen_G_eSports.png": 333,
	"assets/logos/2022_spring_Hanwha_Life_eSports.png": 6663,
	"assets/logos/2022_spring_KT_Rolster.png": 2245,
	"assets/logos/2022_spring_Kwangdong_Freecs.png": 9001,
	"assets/logos/2022_spring_Liiv_SANDBOX.png": 7742,
	"assets/logos/2022_spring_Nongshim_RedForce.png": 532,
	"assets/logos/2022_spring_T1.png": 2587,
	"assets/logos/2022_summer_DRX.png": 8522,
	"assets/logos/2022_summer_DWG_KIA.png": 4282,
	"assets/logos/2022_summer_Fredit_BRION.png": 5221,
	"assets/logos/2022_summer_Gen_G_eSports.png": 1501,
	"assets/logos/2022_summer_Hanwha_Life_eSports.png": 5383,
	"assets/logos/2022_summer_KT_Rolster.png": 693,
	"assets/logos/2022_summer_Kwangdong_Freecs.png": 7641,
	"assets/logos/2022_summer_Liiv_SANDBOX.png": 1278,
	"assets/logos/2022_summer_Nongshim_RedForce.png": 3620,
	"assets/logos/2022_summer_T1.png": 9227,
	"assets/logos/2023_spring_BRION.png": 7973,
	"assets/logos/2023_spring_DRX.png": 5129,
	"assets/logos/2023_spring_Dplus_KIA.png": 6343,
	"assets/logos/2023_spring_Gen_G_eSports.png": 7082,
	"assets/logos/2023_spring_Hanwha_Life_eSports.png": 6700,
	"assets/logos/2023_spring_KT_Rolster.png": 6076,
	"assets/logos/2023_spring_Kwangdong_Freecs.png": 9280,
	"assets/logos/2023_spring_Liiv_SANDBOX.png": 7867,
	"assets/logos/2023_spring_Nongshim_RedForce.png": 807,
	"assets/logos/2023_spring_T1.png": 3710,
	"assets/logos/2023_summer_BRION.png": 237,
	"assets/logos/2023_summer_DRX.png": 6369,
	"assets/logos/2023_summer_Dplus_KIA.png": 2815,
	"assets/logos/2023_summer_Gen_G_eSports.png": 6594,
	"assets/logos/2023_summer_Hanwha_Life_eSports.png": 5764,
	"assets/logos/2023_summer_KT_Rolster.png": 8884,
	"assets/logos/2023_summer_Kwangdong_Freecs.png": 8968,
	"assets/logos/2023_summer_Liiv_SANDBOX.png": 9683,
	"assets/logos/2023_summer_Nongshim_RedForce.png": 6703,
	"assets/logos/2024_spring_DRX.png": 8120,
	"assets/logos/2024_spring_Dplus_KIA.png": 2250,
	"assets/logos/2024_spring_FearX.png": 9036,
	"assets/logos/2024_spring_Gen_G_eSports.png": 3819,
	"assets/logos/2024_spring_Hanwha_Life_eSports.png": 7701,
	"assets/logos/2024_spring_KT_Rolster.png": 5827,
	"assets/logos/2024_spring_Kwangdong_Freecs.png": 3583,
	"assets/logos/2024_spring_Nongshim_RedForce.png": 9930,
	"assets/logos/2024_spring_OK_BRION.png": 5261,
	"assets/logos/2024_spring_T1.png": 6817,
	"assets/logos/2024_summer_DRX.png": 4656,
	"assets/logos/2024_summer_Dplus_KIA.png": 6178,
	"assets/logos/2024_summer_FearX.png": 1332,
	"assets/logos/2024_summer_Gen_G_eSports.png": 2467,
	"assets/logos/2024_summer_Hanwha_Life_eSports.png": 1133,
	"assets/logos/2024_summer_KT_Rolster.png": 4091,
	"assets/logos/2024_summer_Kwangdong_Freecs.png": 6311,
	"assets/logos/2024_summer_Nongshim_RedForce.png": 562,
	"assets/logos/2024_summer_OK_BRION.png": 8517,
	"assets/logos/2024_summer_T1.png": 4361,
	"assets/logos/2025_spring_BNK_FearX.png": 4689,
	"assets/logos/2025_spring_DN_Freecs.png": 3592,
	"assets/logos/2025_spring_DRX.png": 9087,
	"assets/logos/2025_spring_Dplus_KIA.png": 9725,
	"assets/logos/2025_spring_Gen_G_eSports.png": 8944,
	"assets/logos/2025_spring_Hanwha_Life_eSports.png": 10,
	"assets/logos/2025_spring_KT_Rolster.png": 146,
	"assets/logos/2025_spring_Nongshim_RedForce.png": 5709,
	"assets/logos/2025_spring_OK_BRION.png": 7812,
	"assets/logos/2025_spring_T1.png": 9436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5602;